import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  StyledLandingPageWrapper,
  LeftContainer,
  RightContainer,
  TopDescription,
  LeftBottomText,
  LogoContainer,
  WelcomeText,
  Copyright,
  SignInBtnWrapper,
  SignInBtn,
  MsOfficeLogo,
  ErrorWrapper,
  LeftBottomMainText,
  LeftBottomSubText,
  LoaderWrapper
} from "../components/styled/LandingPage.styled";
import Title from "../components/elements/Title";
import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedResources } from "../authConfig";
import { useNavigate } from "react-router-dom";
import { getAuth } from "../services/api/auth";
import LoaderFade from "../components/elements/LoaderFade";
export default function Login() {
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState(false);
  const [displayMsg, setDisplayMsg] = useState("Sign in with Microsoft");
  const [userInactiveError, setUserInactiveError] = useState(null);
  let navigate = useNavigate();
  const account = accounts[0];
  useEffect(() => {
    const login = async () => {
      if (account) {
        try {
          setLoading(true);
          const authResponse = await instance.acquireTokenSilent({
            scopes: protectedResources.authAPI.scopes,
            account: account,
          });
          const auth = await getAuth(authResponse.accessToken);

          if (!auth.is_active) {
            setLoading(false);
            setUserInactiveError("User not active");
          }
          setTimeout(() => {
            if (auth.is_active) {
              auth.accessToken = authResponse.accessToken;
              localStorage.setItem("user", JSON.stringify(auth));
              localStorage.setItem("token", authResponse.accessToken);
              if(auth.web_portal_access){
                navigate("/home");
              }else{
                navigate("/web-map");
              }
            }
            setLoading(false);
          }, 3000);
        } catch (error) {
          //toast.error("You don't have permission to access");
          setDisplayMsg("No permission to access");
          setLoading(false);
        }
      }
    };
    login();
    // eslint-disable-next-line
  }, [account]);

  function handleLogin(i) {
    if (account && displayMsg === "No permission to access") instance.logout(); // logout first if no access
    instance.loginRedirect(loginRequest).catch((e) => {}); // else
  }


  return (
    <StyledLandingPageWrapper>
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <LeftContainer>
            <TopDescription>
              Data and analytics can bring science to your decision
            </TopDescription>
            <LeftBottomText>
            <LeftBottomMainText>
              Network & Planning Analytics
            </LeftBottomMainText>
            <LeftBottomSubText>
              Geospatial Application
            </LeftBottomSubText>
            </LeftBottomText>
          </LeftContainer>
        </Grid>
        <Grid item xs={4}>
          <RightContainer>
            <LogoContainer>
              <img
                src={"/assets/logo.png"}
                alt="logo"
                height={55}
                style={{
                  marginTop: "15px"
                }}
              />
            </LogoContainer>
            <WelcomeText>-Welcome-</WelcomeText>
            <Title nonLink napaVersion/>
            {loading ? (
              <LoaderWrapper>
              <LoaderFade />
            </LoaderWrapper>
            ): userInactiveError ? (
              <SignInBtnWrapper>
                <SignInBtn onClick={() => handleLogin(instance)}>
                  <ErrorWrapper>{userInactiveError}</ErrorWrapper>
                </SignInBtn>
              </SignInBtnWrapper>
            ):(
              <SignInBtnWrapper>
                <SignInBtn onClick={() => handleLogin(instance)}>
                  <MsOfficeLogo>
                      <img
                        src={"./assets/microsoft-windows-logo.png"}
                        alt="ms-office-logo"
                      />
                    </MsOfficeLogo>
                    {displayMsg}
                </SignInBtn>
              </SignInBtnWrapper>
            )}
            <Copyright>© 2022 EDOTCO Group</Copyright>
          </RightContainer>
        </Grid>
      </Grid>
    </StyledLandingPageWrapper>
  );
}
